/* boardlux-20260814s-hero-overlay */
/**
 * Cutting Board Luxury LP — photo hero + light theme CTAs matching pan ATC.
 * EN: Add to cart · NL: In winkelwagen
 */
(function () {
  var root = document.querySelector('.tl-lux[data-lp="cutting-board-luxury"]');
  if (!root) return;

  var money = {};
  try {
    var moneyEl = document.getElementById('tl-lux-board-money');
    if (moneyEl && moneyEl.textContent) money = JSON.parse(moneyEl.textContent) || {};
  } catch (e) {}

  var BOARD = {
    price: money.price || '',
    was: money.was || '',
    hasCompare: !!money.hasCompare,
    badgeEn: money.badgeEn || '',
    badgeNl: money.badgeNl || '',
    variantId: money.variantId || 57831485833603,
    url: money.url || '/products/titanium-cutting-board?variant=57831485833603'
  };

  function qs(sel, el) {
    return (el || root).querySelector(sel);
  }

  function qsa(sel, el) {
    return Array.prototype.slice.call((el || root).querySelectorAll(sel));
  }

  function currentLang() {
    try {
      if (window.Weglot && typeof Weglot.getCurrentLang === 'function') {
        return Weglot.getCurrentLang();
      }
    } catch (e) {}
    var path = (location.pathname || '').toLowerCase();
    if (path === '/nl' || path.indexOf('/nl/') === 0) return 'nl';
    var m = document.cookie.match(/(?:^|; )wglang=([^;]+)/);
    return m ? decodeURIComponent(m[1]) : 'en';
  }

  function applyI18n() {
    var key = currentLang() === 'nl' ? 'nl' : 'en';
    qsa('[data-en][data-nl]').forEach(function (el) {
      if (el.hasAttribute('data-lux-price') || el.hasAttribute('data-lux-was')) return;
      var next = el.getAttribute('data-' + key) || el.getAttribute('data-en');
      if (next != null) el.textContent = next;
    });
  }

  function withSearch(url) {
    var base = url.split('?')[0];
    var keep = (window.location.search || '').replace(/^\?/, '');
    var variant = url.indexOf('variant=') >= 0 ? url.split('variant=')[1].split('&')[0] : '';
    var params = [];
    if (keep) {
      keep.split('&').forEach(function (p) {
        if (p && p.indexOf('variant=') !== 0) params.push(p);
      });
    }
    if (variant) params.unshift('variant=' + variant);
    return params.length ? base + '?' + params.join('&') : base;
  }

  function syncPrices() {
    if (BOARD.price) {
      qsa('[data-lux-price]').forEach(function (el) {
        el.textContent = BOARD.price;
      });
    }
    if (BOARD.was) {
      qsa('[data-lux-was]').forEach(function (el) {
        el.textContent = BOARD.was;
      });
    }
    qsa('[data-lux-pdp], [data-lux-atc]').forEach(function (el) {
      if (el.tagName === 'A') el.setAttribute('href', withSearch(BOARD.url));
    });
  }

  function addToCart(btn) {
    if (!btn || btn.getAttribute('aria-busy') === 'true') return;
    var prev = btn.textContent;
    btn.setAttribute('aria-busy', 'true');
    btn.classList.add('is-loading');
    btn.textContent = currentLang() === 'nl' ? 'Bezig…' : 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: BOARD.variantId, quantity: 1 }] }),
      credentials: 'same-origin'
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add_failed');
        window.location.href = '/cart';
      })
      .catch(function () {
        window.location.href = withSearch(BOARD.url);
      });
  }

  qsa('[data-lux-atc]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      addToCart(btn);
    });
  });

  var fadeEls = qsa('[data-fade]');
  if ('IntersectionObserver' in window && fadeEls.length) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    fadeEls.forEach(function (el) {
      io.observe(el);
    });
  } else {
    fadeEls.forEach(function (el) {
      el.classList.add('is-in');
    });
  }

  var sticky = qs('#tl-lux-sticky');
  var hero = qs('.tl-lux-hero');
  var offer = qs('#offer') || hero;
  var nav = qs('.tl-lux-nav');
  if (sticky && offer) {
    // Sticky ATC only after leaving the buy/hero section — never in header
    sticky.classList.remove('is-on');
    sticky.setAttribute('aria-hidden', 'true');
    var on = false;
    function toggleSticky() {
      var offerBottom = offer.getBoundingClientRect().bottom;
      var should = offerBottom < 80 && window.scrollY > 120;
      if (should === on) return;
      on = should;
      sticky.classList.toggle('is-on', on);
      sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      document.body.classList.toggle('tl-lux-sticky-pad', on);
    }
    window.addEventListener('scroll', toggleSticky, { passive: true });
    window.addEventListener('resize', toggleSticky, { passive: true });
    toggleSticky();
  }

  if (nav && hero) {
    function toggleNavSolid() {
      var past = hero.getBoundingClientRect().bottom < 72;
      nav.classList.toggle('is-solid', past);
    }
    window.addEventListener('scroll', toggleNavSolid, { passive: true });
    window.addEventListener('resize', toggleNavSolid, { passive: true });
    toggleNavSolid();
  }

  var media = qs('.tl-lux-hero--photo .tl-lux-hero__bg img');
  if (media && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    window.addEventListener(
      'scroll',
      function () {
        var y = Math.min(28, Math.max(0, window.scrollY * 0.05));
        media.style.transform = 'scale(1.02) translate3d(0,' + y + 'px,0)';
      },
      { passive: true }
    );
  }

  syncPrices();
  applyI18n();
  try {
    if (window.Weglot && typeof Weglot.on === 'function') {
      Weglot.on('languageChanged', applyI18n);
    }
  } catch (e) {}
})();
